import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { RBACProvider } from './contexts/RBACContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { Dashboard } from './pages/Dashboard';
import { LoginPage } from './pages/LoginPage';
import { ClientsPage } from './pages/ClientsPage';
import { ClientDetailPage } from './pages/ClientDetailPage';
import { WorkersPage } from './pages/WorkersPage';
import { ContractsPage } from './pages/ContractsPage';
import { InvoicingPage } from './pages/InvoicingPage';
import { OperationsPage } from './pages/OperationsPage';
import { ActionsPage } from './pages/ActionsPage';
import { CommercialPage } from './pages/CommercialPage';
import { NonConformitiesPage } from './pages/NonConformitiesPage';
import { DeadlinesPage } from './pages/DeadlinesPage';
import { EquipmentPage } from './pages/EquipmentPage';
import { TicketsPage } from './pages/TicketsPage';
import { TrainingPage } from './pages/TrainingPage';
import { StudiesPage } from './pages/StudiesPage';
import { NotificationCenter } from './components/NotificationCenter';
import { QuickTicket } from './components/QuickTicket';
// Component to conditionally render global UI elements
function GlobalUI() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  if (isLoginPage) return null;
  return <>
      <div className="fixed top-4 right-4 z-50" data-id="element-0">
        <NotificationCenter data-id="element-1" />
      </div>
      <QuickTicket data-id="element-2" />
    </>;
}
export function App() {
  return <RBACProvider data-id="element-3">
      <NotificationProvider data-id="element-4">
        <Router data-id="element-5">
          <div className="relative" data-id="element-6">
            <Routes data-id="element-7">
              <Route path="/login" element={<LoginPage data-id="element-9" />} data-id="element-8" />
              <Route path="/" element={<Dashboard data-id="element-11" />} data-id="element-10" />
              <Route path="/clients" element={<ClientsPage data-id="element-13" />} data-id="element-12" />
              <Route path="/clients/:id" element={<ClientDetailPage data-id="element-15" />} data-id="element-14" />
              <Route path="/clients/:id/:section" element={<ClientDetailPage data-id="element-17" />} data-id="element-16" />
              <Route path="/workers" element={<WorkersPage data-id="element-19" />} data-id="element-18" />
              <Route path="/contracts" element={<ContractsPage data-id="element-21" />} data-id="element-20" />
              <Route path="/invoicing" element={<InvoicingPage data-id="element-23" />} data-id="element-22" />
              <Route path="/operations" element={<OperationsPage data-id="element-25" />} data-id="element-24" />
              <Route path="/actions" element={<ActionsPage data-id="element-27" />} data-id="element-26" />
              <Route path="/commercial" element={<CommercialPage data-id="element-29" />} data-id="element-28" />
              <Route path="/non-conformities" element={<NonConformitiesPage data-id="element-31" />} data-id="element-30" />
              <Route path="/deadlines" element={<DeadlinesPage data-id="element-33" />} data-id="element-32" />
              <Route path="/equipment" element={<EquipmentPage data-id="element-35" />} data-id="element-34" />
              <Route path="/tickets" element={<TicketsPage data-id="element-37" />} data-id="element-36" />
              <Route path="/training" element={<TrainingPage data-id="element-39" />} data-id="element-38" />
              <Route path="/studies" element={<StudiesPage data-id="element-41" />} data-id="element-40" />
            </Routes>
            <GlobalUI data-id="element-42" />
          </div>
        </Router>
      </NotificationProvider>
    </RBACProvider>;
}